(function () {
    'use strict';

    angular.module('app')
        .controller('AdminFormController', AdminFormController);

    /* @ngInject */
    function AdminFormController($timeout, $state, AlertService, Auth, roles, itemData) {
        var vm = this;


        vm.registerAccount = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';
        $timeout(function () {
            angular.element('.form-group:eq(0)>input')[0].focus();
        });

        vm.roles = roles;


        vm.register = function () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                AlertService.error("admin.register.error.dontmatch");
            } else {
                Auth.createAccount(vm.registerAccount).then(function () {
                    $state.go("admin/admin/list");
                });
            }
        };
    }
})();
